import { lazy } from 'react';

import { Routes } from '@app/constants/routes';
import { MyRouteObject } from '@app/models/router';
import { AuthStatus } from '@app/auth/api/auth.type';

import { AuthModule } from './AuthModule';
// import { SignUp } from './pages/SignUp.page';
import { TypedNavigate } from '@app/router';

const SignInPage = lazy(() => import('./pages/SignInPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const SignInStep2Page = lazy(() => import('./pages/SignInStep2Page'));
const ConfirmUserPage = lazy(() => import('./pages/ConfirmUserPage'));
const SuccessfullyLoggedInPage = lazy(() => import('./pages/SuccessfullyLoggedInPage'));

export const AuthRoutes: MyRouteObject = {
  path: Routes.auth.index,
  element: <AuthModule />,
  authStatus: AuthStatus.UNAUTHORIZED,
  children: [
    { path: Routes.auth.sign_in, element: <SignInPage /> },
    { path: Routes.auth.sign_in_step_2, element: <SignInStep2Page /> },
    // TODO: maybe remove
    // { path: Routes.auth.sign_up, element: <SignUp /> },
    { path: Routes.auth.forgot_password, element: <ForgotPasswordPage /> },
    { path: Routes.auth.confirm_user, element: <ConfirmUserPage /> },
    { path: Routes.auth.successfully_logged_in, element: <SuccessfullyLoggedInPage /> },
    { index: true, path: '*', element: <TypedNavigate to={Routes.auth.sign_in} /> },
  ],
};
